import { useEffect, useState } from "react";
import { api, type StructureType } from "./api";

export function useStructureTypes() {
  const [types, setTypes] = useState<StructureType[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    loadTypes();
  }, []);

  async function loadTypes() {
    try {
      setLoading(true);
      const response = await api.listStructureTypes();
      setTypes(response.structure_types);
      setError(null);
    } catch (err) {
      console.error("Failed to load structure types:", err);
      setError("Fehler beim Laden der Struktur-Typen");
    } finally {
      setLoading(false);
    }
  }

  const getTypeByKey = (key: string) => {
    return types.find((t) => t.key === key);
  };

  return { types, structureTypes: types, loading, error, reload: loadTypes, getTypeByKey };
}
